import { useEffect, useState } from 'react';
import { getLatestArticles } from '../../../helpers/BuilderHelper';
import { useLocale } from '../../../helpers/LangHelper';
import { Article } from '../../../types/Article';
import B2BHeadliningArticlesBlock from '../b2b-headlining-articles-block/b2b-headlining-articles-block';

export interface B2BHeadliningLatestArticlesProps {
    offset: number;
    showSignupForAfterpay: boolean;
    articles: Article[];
}

export const B2BHeadliningLatestArticles = (props: B2BHeadliningLatestArticlesProps) => {
    const { locale } = useLocale();

    const [featuredArticles, setFeaturedArticles] = useState<Article[]>(props.articles || []);
    // const [isFirstLoad, setIsFirstLoad] = useState(true);

    useEffect(() => {
        let cancelled = false;

        const fetchArticles = async () => {
            try {
                const articles = await getLatestArticles({ locale, offset: props.offset ?? 1, limit: 3 });

                if (Array.isArray(articles)) {
                    setFeaturedArticles([...articles]);
                } else {
                    console.error('Articles are not an array or fetch was cancelled');
                }
            } catch (error) {
                console.error('Error fetching articles:', error);
            }
        };
        fetchArticles();

        // if (isFirstLoad) {
        //     setIsFirstLoad(false);
        // }

        return () => {
            cancelled = true;
        };
    }, [locale, props.offset]);

    useEffect(() => {}, [featuredArticles]);

    return <B2BHeadliningArticlesBlock cardData={featuredArticles} showSignupCard={props.showSignupForAfterpay ?? false} />;
};
